import { Component, computed, Directive, input } from '@angular/core';
import { cn } from './cn';

/**
 * Replaces mat-form-field with floating-label-free pattern:
 *   <hlm-form-field>
 *     <label hlmLabel for="x">First name</label>
 *     <input id="x" hlmInput ... />
 *     <p hlmFieldHint>Max 30 chars</p>
 *     <p hlmFieldError>Required</p>
 *   </hlm-form-field>
 */
@Component({
  selector: 'hlm-form-field',
  standalone: true,
  template: '<ng-content />',
  host: { '[class]': '_c()' },
})
export class HlmFormFieldComponent {
  readonly userClass = input<string>('', { alias: 'class' });
  protected readonly _c = computed(() => cn('flex flex-col gap-1.5', this.userClass()));
}

@Directive({
  selector: 'label[hlmLabel]',
  standalone: true,
  host: { '[class]': '_c()' },
})
export class HlmLabelDirective {
  readonly userClass = input<string>('', { alias: 'class' });
  protected readonly _c = computed(() =>
    cn(
      // Mockup parity (EB-3642 Add Billing dialog): Geist Sans uppercase, xs,
      // medium weight, subtle tracking, muted foreground. Monospace rendering
      // reads too technical for form field labels in dense dialog layouts.
      'text-xs font-medium uppercase tracking-[0.10em] text-muted-foreground',
      this.userClass(),
    ),
  );
}

@Directive({
  selector: '[hlmFieldHint]',
  standalone: true,
  host: { '[class]': '_c()' },
})
export class HlmFieldHintDirective {
  readonly userClass = input<string>('', { alias: 'class' });
  protected readonly _c = computed(() =>
    cn('m-0 text-sm text-muted-foreground', this.userClass()),
  );
}

@Directive({
  selector: '[hlmFieldError]',
  standalone: true,
  host: { '[class]': '_c()' },
})
export class HlmFieldErrorDirective {
  readonly userClass = input<string>('', { alias: 'class' });
  protected readonly _c = computed(() =>
    cn('m-0 text-sm font-medium text-destructive', this.userClass()),
  );
}

export const HLM_FORM_FIELD = [
  HlmFormFieldComponent,
  HlmLabelDirective,
  HlmFieldHintDirective,
  HlmFieldErrorDirective,
] as const;
